import { gql } from '@apollo/client';

const GET_SUBMITTED_FEEDBACK_DATA = gql`
  query GetSubmittedFeedbacksData {
    submittedFeedbacks {
      SubmitterRole
      SubmitterEmail
      SubmitterName
      SubmittedDate
      Comment
    }
  }
`;

export default GET_SUBMITTED_FEEDBACK_DATA;
